import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.components.modal`, {
  'components.modal.close': `Close`,
  'components.modal.close-modal': `Close modal`,
  'components.modal.close-window': `Close Window`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.components.modal"), "fr": () => import("virtual:i18n-scope/fr/common.components.modal"), "id": () => import("virtual:i18n-scope/id/common.components.modal"), "ja": () => import("virtual:i18n-scope/ja/common.components.modal"), "ko": () => import("virtual:i18n-scope/ko/common.components.modal"), "pt": () => import("virtual:i18n-scope/pt/common.components.modal"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.components.modal"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.components.modal")});
export default __i18nScope;
